/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */

/**
 * Country code of the phone number
 */
export type CountryCodes = (typeof CountryCodes)[keyof typeof CountryCodes];

export const CountryCodes = {
  US: 'US',
  GB: 'GB',
  HK: 'HK',
  JP: 'JP',
  AU: 'AU',
} as const;
